import React from "react";

export default function PrivacyPolicy() {
  const effectiveDate = new Date().toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });
  return (
    <div className="container-fluid maxContainerSection paddingTop">
      <div className="row commonPadding alignCenterSection">
        <div className="col-md-10">
          <div className="policyHeader">
            <h2 className="m-0 headingTwo">PrivacyPolicy</h2>
            <p className="m-0 peraGraph">Effective Date : {effectiveDate}</p>
            <p className="m-0 peraGraph">
              Miaxa (“we,” “our,” or “us”) respects your privacy. This Privacy
              Policy explains how we collect, use, store, and protect your
              information when you use the Miaxa mobile application and related
              services.
            </p>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">1. Information We Collect</h3>
            <h4 className="m-0 headerFour">Personal Information</h4>
            <ul>
              <li>Full name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Profile photo (if uploaded)</li>
              <li>Account login credentials</li>
            </ul>

            <h4 className="m-0 headerFour">Location Information</h4>
            <p className="m-0 spanText">Because Miaxa is a location-based app, we collect:</p>
            <ul>
              <li>Real-time GPS location</li>
              <li>Background location (if permission granted)</li>
              <li>
                Device location history (only when app is active or permitted)
              </li>
            </ul>
            <h4 className="m-0 headerFour">Device & Usage Information</h4>
            <ul>
              <li>Device type and model</li>
              <li>Operating system</li>
              <li>IP address</li>
              <li>App usage data</li>
              <li>Crash logs and analytics</li>
            </ul>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">2. How We Use Your Information</h3>
            <p className="m-0 spanText">We use your data to:</p>
            <ul>
              <li>Provide accurate location-based services</li>
              <li>Show nearby places/services</li>
              <li>Improve user experience</li>
              <li>Personalize recommendations</li>
              <li>Communicate updates and notifications</li>
              <li>Ensure security and prevent fraud</li>
            </ul>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">3. Location Data Usage</h3>
            <p className="m-0 spanText">Miaxa collects and processes your location to:</p>
            <ul>
              <li>Display nearby businesses or users</li>
              <li>Provide navigation assistance</li>
              <li>Improve service accuracy</li>
            </ul>
            <p className="m-0 spanText">Location data is:</p>
            <ul>
              <li>Not sold to third parties</li>
              <li>Used strictly for app functionality</li>
              <li>Stored securely and only as long as necessary</li>
            </ul>
            <p className="m-0 spanText">
              You can disable location permissions anytime from your device
              settings.
            </p>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">4. Sharing of Information</h3>
            <p className="m-0 spanText">We may share data:</p>
            <ul>
              <li>With service providers (hosting, analytics, maps API)</li>
              <li>If required by law</li>
              <li>To protect rights, safety, or prevent fraud</li>
            </ul>
            <p className="m-0 spanText">We do not sell personal data.</p>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">5. Data Security</h3>
            <p className="m-0 spanText">We implement:</p>
            <ul>
              <li>Secure servers</li>
              <li>Encrypted connections (HTTPS/SSL)</li>
              <li>Restricted access controls</li>
            </ul>
            <p className="m-0 spanText">However, no system is 100% secure.</p>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">6. Data Retention</h3>
            <p className="m-0 spanText">We retain personal information:</p>
            <ul>
              <li>As long as your account is active</li>
              <li>As required by law</li>
              <li>Until you request deletion</li>
            </ul>
            <p className="m-0 spanText">You may request account deletion at any time.</p>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">7. Your Rights</h3>
            <p className="m-0 spanText">You have the right to:</p>
            <ul>
              <li>Access your data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion</li>
              <li>Withdraw consent</li>
            </ul>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">8. Children’s Privacy</h3>
            <p className="m-0 spanText">
              Miaxa is not intended for children under 13 (or applicable local
              age). We do not knowingly collect data from children.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
